export type ShiftTimes = { open: string; close: string };

function toMinutes(time: string): number {
  const [h, m] = time.split(':');
  return Number(h) * 60 + Number(m);
}

function rangesOverlap(s1: number, e1: number, s2: number, e2: number): boolean {
  return s1 < e2 && s2 < e1;
}

function toRanges(start: number, end: number): [number, number][] {
  if (end > start) return [[start, end]];
  return [
    [start, 1440],
    [0, end],
  ];
}

export function shiftsOverlap(a: ShiftTimes, b: ShiftTimes): boolean {
  const rangesA = toRanges(toMinutes(a.open), toMinutes(a.close));
  const rangesB = toRanges(toMinutes(b.open), toMinutes(b.close));
  for (const [s1, e1] of rangesA) {
    for (const [s2, e2] of rangesB) {
      if (rangesOverlap(s1, e1, s2, e2)) return true;
    }
  }
  return false;
}

export function hasOverlappingShifts(shifts: ShiftTimes[]): boolean {
  for (let i = 0; i < shifts.length; i++) {
    for (let j = i + 1; j < shifts.length; j++) {
      if (shiftsOverlap(shifts[i], shifts[j])) return true;
    }
  }
  return false;
}
